import React from 'react'
import { Outlet } from 'react-router-dom'

const SpecificPostPage = () => {
  return (
    <div>
        <Outlet />
    </div>
  )
}

export default SpecificPostPage
